export default {
  OPEN_HELP_CENTER: 'openHelpCenter',
  CLOSE_HELP_CENTER: 'closeHelpCenter',
};
